import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-attendance-report',
  templateUrl: './attendance-report.component.html',
  styleUrls: ['./attendance-report.component.scss'],
})
export class AttendanceReportComponent  implements OnInit {

  filteredAssets: any = [];
  searchTerm: string = '';
  attendanceForm!: FormGroup;

  constructor(private fb: FormBuilder) {

  }

  ngOnInit(): void {
    this.attendanceForm = this.fb.group({
      selectedProgram: [''],
      selectedStatus: [''],
      searchTerm: ['']
    });
  }



  filterAssets(searchTerm: string) {
    console.log(searchTerm);
  }

  programList: string[] = ['Program 1', 'Program 2']; 
  attendanceList: string[] = ['Present', 'Absent']; 

  trainingPrograms = [
    {
      title: 'Problem Solving',
      startDate: '1-10-24',
      endDate: '15-10-24',
      empCode: 'B001',
      empName:'Ram',
      department: 'Sales',
      band: 'A',
      grade: 'Junior',      
      status: 'absent'
    },
    {
      title: 'Excel',
      startDate: '1-10-24',
      endDate: '15-10-24',
      empCode: 'B002',
      empName:'Ram',
      department: 'Lakshman',
      band: 'A',
      grade: 'Manager',      
      status: 'present'
    }
  ];
  
  

// Define headers dynamically
tableHeaders = [
  { label: 'Programme Title', key: 'title' },
  { label: 'Start Date', key: 'startDate' },
  { label: 'End Date', key: 'endDate' },
  { label: 'Emp Code', key: 'empCode' },
  { label: 'Emp Name', key: 'empName' },
  { label: 'Department', key: 'department' },
  { label: 'Band', key: 'band' },
  { label: 'Grade', key: 'grade' },
  { label: 'Status', key: 'status' },
];

  
  
}
